<div
  class="relative w-full max-w-[95%] sm:max-w-[90%] md:max-w-[85%] lg:max-w-[80%] xl:max-w-[75%] mx-auto"
  >
  <!-- Search Container with Animation -->
  <div
    class="flex items-center w-full bg-white rounded-full shadow-lg border overflow-hidden transition-all duration-300 ease-in-out search-container"
    [ngClass]="{
      'border-amber-400 shadow-xl transform scale-105': isActive,
      'border-gray-200': !isActive
    }"
    (click)="toggleActive($event)"
    >
    <!-- Search Icon with Animation -->
    <div class="pl-4 pr-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-500 transition-transform duration-300"
        [ngClass]="{ 'scale-110 text-amber-500': isActive }"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>

      <!-- Search Input -->
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (input)="onSearchInput($event)"
        placeholder="Buscar productos, categorías..."
        class="w-full py-3 px-2 text-gray-700 focus:outline-none text-sm transition-all duration-300"
        [ngClass]="{ 'font-medium': isActive }"
        [disabled]="!isOpen"
        />

        <!-- Clear Button (shows when active) -->
        @if (isActive) {
          <div class="pr-2 opacity-0 animate-fadeIn">
            <button
              class="p-1 rounded-full hover:bg-gray-100 transition-colors duration-200"
              (click)="clearSearch($event)"
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 text-gray-400 hover:text-gray-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          }
        </div>

        <!-- Search Results Dropdown -->
        @if (showResults && filteredProducts.length > 0) {
          <div
            class="absolute z-50 w-full mt-2 bg-white rounded-lg shadow-xl border border-gray-200 max-h-[400px] overflow-y-auto"
            >
            @for (product of filteredProducts; track product) {
              <div
                (click)="selectProduct(product)"
                class="px-4 py-2 hover:bg-gray-50 cursor-pointer flex items-center"
                >
                @if (product.pd_image) {
                  <img
                    [src]="product.pd_image"
                    class="w-10 h-10 object-cover rounded mr-3"
                    (error)="onImageError($event)"
                    />
                }
                <div>
                  <div class="text-sm font-medium text-gray-900">
                    {{ product.pd_name }}
                  </div>
                  <div class="text-xs text-gray-500">
                    {{ product.pd_unit_price | currency }}
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- El modal ahora se muestra a nivel de aplicación -->
